import { Routes } from '@angular/router';

import { AuthGuard } from '../auth/guards/auth.guard';
import { BluePrintRoutes } from '../../features/bluePrint/bluePrint.routes';
import { DashboardRoutes } from '../../features/dashboard/dashboard.routes';
import { InvoicesRoutes } from '../../features/invoices/invoices.routes';
import { passengersRoutes } from '../../features/passengers/passengers.routes';
import { PlacesRoutes } from '../../features/places/places.routes';
import { reportsRoutes } from '../../features/reports/reports.routes';
import { ProfileRoutes } from 'src/app/features/profile/profile.routes';
import { googlemapsInitializerResolver } from '../auth/services/googlemaps-initializer.resolver';
import { LibraryThemeGuard } from 'src/app/shared/services/library-theme.guard';
import { PermissionsList } from 'src/app/shared/common/PermissionList';
import { AuthorizationGuard } from '../auth/guards/authorization.guard';
export const mainRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      ...BluePrintRoutes,
      ...DashboardRoutes,
      ...InvoicesRoutes,
      ...passengersRoutes,
      ...PlacesRoutes,
      ...reportsRoutes,
      ...ProfileRoutes,
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dispatch',
        loadChildren: () => import('@gozetta/dispatch-portal').then(m => m.routes),
        canActivate: [LibraryThemeGuard, AuthorizationGuard],
        canDeactivate: [LibraryThemeGuard],
        title: 'Active Rides | ADROIT',
        data: {
          animation: 'active rides',
          PermissionPageName: [PermissionsList[PermissionsList.RideMonitorView]],
        }
      },
    ],
    canActivate: [AuthGuard],
    resolve: {
      googleMapsInitialized: googlemapsInitializerResolver,
    },
    title: 'main-layout',
  },
];
